<div class="p-2">
  <h4>Record any match (admin)</h4>
  <p class="text-muted small mb-3">
    Scores are in <strong>pairing order</strong>: the first row is Player 1, the second row is Player 2.
    For <strong>Forfeit</strong> / <strong>Retired</strong>, Player 1 wins. For tournament ladders, select the ladder id that ends with <code>-Tourney</code> when applicable.
  </p>

  <form [formGroup]="filterForm" class="mb-3">
    <label>Ladder</label>
    <select class="form-select form-select-sm mb-2" formControlName="ladderId">
      <option *ngFor="let l of ladders" [value]="l.ladderId">{{ l.ladderId }} — {{ l.name }}</option>
    </select>
    <label>Level</label>
    <select class="form-select form-select-sm" formControlName="levelId" [compareWith]="compareLevelId">
      <option *ngFor="let lv of levels" [ngValue]="numericLevelId(lv)">
        {{ numericLevelId(lv) }} — {{ lv.nameLong }}
      </option>
    </select>
  </form>

  <div *ngIf="busyLoadPairings">Loading unplayed matches…</div>
  <div *ngIf="message" class="alert alert-success py-2">{{ message }}</div>
  <div *ngIf="error" class="alert alert-danger py-2">{{ error }}</div>

  <form *ngIf="!busyLoadPairings && pairings.length > 0" [formGroup]="matchForm">
    <div class="mb-2">
      <label>Match</label>
      <select class="form-select form-select-sm" formControlName="pairingId">
        <option *ngFor="let p of pairings" [ngValue]="p.pairingId">
          Round {{ p.round }}: {{ p.player1Name }} vs {{ p.player2Name }}
        </option>
      </select>
    </div>

    <div *ngIf="isTiebreakLadder" class="alert alert-info py-2 small">
      Tiebreak ladder: enter <strong>only</strong> the first-row / second-row tie-break points (one side must be 10).
    </div>

    <table class="table table-sm" *ngIf="selectedPairing">
      <tr>
        <th></th>
        <th>Set 1</th>
        <th>Set 2</th>
        <th>Set 3</th>
      </tr>
      <tr>
        <td>{{ selectedPairing.player1Name }}</td>
        <td>
          <ng-container *ngIf="!isTiebreakLadder">
            <select formControlName="Set1Player1Score">
              <option *ngFor="let s of possibleScores" [value]="s">{{ s }}</option>
            </select>
            <select class="ms-1" formControlName="Set1Player1Tie" *ngIf="+matchForm.value.Set1Player1Score! + +matchForm.value.Set1Player2Score! == 13">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{ i }}</option>
            </select>
          </ng-container>
          <ng-container *ngIf="isTiebreakLadder">
            <select formControlName="Set1Player1Tie">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{ i }}</option>
            </select>
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="!isTiebreakLadder">
            <select formControlName="Set2Player1Score">
              <option *ngFor="let s of possibleScores" [value]="s">{{ s }}</option>
            </select>
            <select class="ms-1" formControlName="Set2Player1Tie" *ngIf="+matchForm.value.Set2Player1Score! + +matchForm.value.Set2Player2Score! == 13">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{ i }}</option>
            </select>
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="!isTiebreakLadder">
            <select formControlName="Set3Player1Score">
              <option *ngFor="let s of possibleScores" [value]="s">{{ s }}</option>
            </select>
            <select class="ms-1" formControlName="Set3Player1Tie" *ngIf="+matchForm.value.Set3Player1Score! + +matchForm.value.Set3Player2Score! == 13">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{ i }}</option>
            </select>
          </ng-container>
        </td>
      </tr>
      <tr>
        <td>{{ selectedPairing.player2Name }}</td>
        <td>
          <ng-container *ngIf="!isTiebreakLadder">
            <select formControlName="Set1Player2Score">
              <option *ngFor="let s of possibleScores" [value]="s">{{ s }}</option>
            </select>
            <select class="ms-1" formControlName="Set1Player2Tie" *ngIf="+matchForm.value.Set1Player1Score! + +matchForm.value.Set1Player2Score! == 13">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{ i }}</option>
            </select>
          </ng-container>
          <ng-container *ngIf="isTiebreakLadder">
            <select formControlName="Set1Player2Tie">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{ i }}</option>
            </select>
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="!isTiebreakLadder">
            <select formControlName="Set2Player2Score">
              <option *ngFor="let s of possibleScores" [value]="s">{{ s }}</option>
            </select>
            <select class="ms-1" formControlName="Set2Player2Tie" *ngIf="+matchForm.value.Set2Player1Score! + +matchForm.value.Set2Player2Score! == 13">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{ i }}</option>
            </select>
          </ng-container>
        </td>
          <td>
          <ng-container *ngIf="!isTiebreakLadder">
            <select formControlName="Set3Player2Score">
              <option *ngFor="let s of possibleScores" [value]="s">{{ s }}</option>
            </select>
            <select class="ms-1" formControlName="Set3Player2Tie" *ngIf="+matchForm.value.Set3Player1Score! + +matchForm.value.Set3Player2Score! == 13">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{ i }}</option>
            </select>
          </ng-container>
        </td>
      </tr>
    </table>

    <button type="button" class="btn btn-primary btn-sm me-2" [disabled]="!canSave() || busySave" (click)="saveMatch($event)">
      Submit match
    </button>
    <button type="button" class="btn btn-outline-secondary btn-sm me-2" [disabled]="busySave" (click)="saveRetired($event)">Retired (P1 wins)</button>
    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="busySave" (click)="saveForfeit($event)">Forfeit (P1 wins)</button>
  </form>

  <p *ngIf="!busyLoadPairings && pairings.length === 0 && filterForm.value.ladderId" class="text-muted">
    No unplayed matches for this ladder and level.
  </p>
</div>
